var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 24,
    viewBox: "0 0 5 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16747",
    "data-name": "Group 16747",
    transform: "translate(1302 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_294",
    "data-name": "Ellipse 294",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(-1302 -5)",
    fill: "#ec6321"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_295",
    "data-name": "Ellipse 295",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(-1302 14)",
    fill: "#ec6321"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_296",
    "data-name": "Ellipse 296",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(-1302 4.5)",
    fill: "#ec6321"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.b734457ebbba2d6ed4947961a62e43fd.svg";
export { ForwardRef as ReactComponent };